import { useFeatureFlagEnabled, useFeatureFlagPayload } from 'posthog-js/react'

const GLOBAL_BANNER_FLAG = 'global-banner'

export interface GlobalBannerPayload {
  variant: 'warning' | 'error' | 'success'
  message: string
}

interface UseGlobalBannerResult {
  isEnabled: boolean
  payload: GlobalBannerPayload | null
}

export const useGlobalBanner = (): UseGlobalBannerResult => {
  const isEnabled = useFeatureFlagEnabled(GLOBAL_BANNER_FLAG)
  const rawPayload = useFeatureFlagPayload(GLOBAL_BANNER_FLAG)

  const payload = isValidPayload(rawPayload) ? rawPayload : null

  return {
    isEnabled: Boolean(isEnabled && payload),
    payload,
  }
}

function isValidPayload(payload: unknown): payload is GlobalBannerPayload {
  if (!payload || typeof payload !== 'object') {
    return false
  }

  const p = payload as Record<string, unknown>

  return (
    typeof p.message === 'string' &&
    typeof p.variant === 'string' &&
    ['warning', 'error', 'success'].includes(p.variant)
  )
}
